<script>

export default {
    name: 'UserCard',
    props: {
        _id: String,
        name: String,
        email: String,
        active: Boolean,
    }
}
</script>


<template>
    <div class="card">
        <img src="../../assets/userIcon.png" alt="Photo de l'utilisateur" v-on:click="$emit('clicked-link')">
        <div class="card__content">
            <div class="card__content__title" v-on:click="$emit('clicked-link')">{{ name }}</div>
            <div class="card__content__email" v-on:click="$emit('clicked-link')">{{ email }}</div>
            
            <div class="card__content__fillBlank" v-on:click="$emit('clicked-link')"></div>

            <span v-if="active" v-on:click="$emit('disable-user', _id)" class="material-icons">delete_outline</span>
            <div v-else><span v-on:click="$emit('enable-user', _id)" class="material-icons">restore_from_trash</span></div>
        </div>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';


.card{
    @include myBlock;
    width: 100%;
    height: 100px;
    display: flex;
    overflow: hidden;

    & img{
        cursor: pointer;
        width: 100px;
        
    }

    &__content{
        display: flex;
        flex-direction: column;
        margin: 8px 0 8px 10px;

        &__title{
            color: $main;
            @include myFont;
            cursor: pointer;
        }

        &__email{
            color: $black-bold;
            @include myFont;
            cursor: pointer;
            font-size: 13px;
        }

        &__fillBlank{
            flex:1;
            cursor: pointer;
        }
    }
}

.material-icons{
    color: $black-bolder;
    max-width: 20px;
    cursor: pointer;

    &:hover{
        color: $color2;
    }
}

</style>
